import TaskType from '../Models/TaskType';
import DataGridRequest from './DataGridRequest';
export class DealPipelineRequest extends DataGridRequest<TaskType> {
    Url = '/api/v1/settings/deal_pipelines';
}
